import React, { Component } from 'react';
import type { Store } from 'redux';
import AppBase from '@atlassian/jira-app-base';
import AppStyle from '@atlassian/jira-common-components-app-style';
import type { ProjectContext } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import type { TenantContext } from '@atlassian/jira-shared-types/src/tenant-context.tsx';
import { CHAT_APP_ID } from './common/constants';
import type { State } from './model/types';
import rootEpic from './ops';
import createStore from './state';
import View from './view';

export type Props = {
	tenantContext: TenantContext;
	projectContext: ProjectContext | null;
};

// eslint-disable-next-line jira/react/no-class-components
export default class ChatSettings extends Component<Props> {
	constructor(props: Props) {
		super(props);

		const { baseUrl, environment } = props.tenantContext;

		// If environment is null it will be treated as prod; we set it to an empty string just to satisfy type checking
		this.store = createStore(rootEpic, baseUrl, environment || '');
	}

	store: Store<State>;

	render() {
		const { tenantContext, projectContext } = this.props;
		return (
			<AppBase id={CHAT_APP_ID} store={this.store}>
				<AppStyle>
					<View tenantContext={tenantContext} projectContext={projectContext} />
				</AppStyle>
			</AppBase>
		);
	}
}
